var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRateStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11722 8.38311C2.32133 8.54067 2.57558 8.49053 2.85131 8.29L4.65967 6.96148L6.46087 8.29C6.74018 8.49053 6.99442 8.54067 7.19854 8.38311C7.39907 8.22913 7.44204 7.97488 7.33461 7.65976L6.61843 5.53628L8.44111 4.23283C8.71684 4.03588 8.83859 3.8067 8.75623 3.5632C8.67387 3.32328 8.44469 3.20511 8.10451 3.20869L5.8736 3.22659L5.19322 1.09237C5.08938 0.766503 4.91391 0.583877 4.65967 0.583877C4.40184 0.583877 4.22638 0.766503 4.12253 1.09237L3.44216 3.22659L1.20767 3.20869C0.871061 3.20511 0.641883 3.32328 0.559522 3.55962C0.477161 3.8067 0.598912 4.03588 0.874642 4.23283L2.69733 5.53628L1.98114 7.65976C1.87372 7.97488 1.91669 8.22913 2.11722 8.38311Z",
    fill: "#EE8834"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateStar);
export default __webpack_public_path__ + "static/media/rate-star.7ebda54376792102f537cb67759aba29.svg";
export { ForwardRef as ReactComponent };